/* eslint-disable */
export default {
  attachFiles: 'ファイルを添付',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
